export const BUDGET_TYPES = [
    'CASH',
    'BARYA'
];


// WEBPACK FOOTER //
// ./src/app/contants/BUDGET_TYPES.ts